import React, { Component } from "react";

import Navigation from "./Navigation";

class App extends Component {
  render() {
    return <Navigation />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js